import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { DateTime } from 'luxon';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { Refreshable } from '../../../../../utils/refreshable.interface';
import it from './i18n/dashboard-page.it.json';

@Component({
  selector: 'app-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.scss']
})
export class DashboardPageComponent implements OnInit {

  @ViewChildren('refreshable') refreshables!: QueryList<Refreshable>;

  private refresh$$ = new BehaviorSubject<void>(undefined);
  lastUpdate$: Observable<Date> = this.refresh$$.pipe(
    map(() => DateTime.local().toJSDate()),
    startWith(DateTime.local().toJSDate())
  );

  constructor(
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit() {
  }

  refresh() {
    this.refreshables.forEach(r => r.refresh());
    this.refresh$$.next();
  }

}
